import ServiceHeader from "../../ServiceComponents/ServiceHeader";
import { getServiceDetails } from "../../api/api";
import { FaGreaterThan } from "react-icons/fa6";
import { GoArrowRight } from "react-icons/go";
import { useParams, Link } from "react-router-dom";
import { useState, useEffect } from "react";

import ServiceSection from "../../PageElements/HomePageElements/ServiceSection";
import ConsultSection from "../../PageElements/HomePageElements/ConsultSection";
import storedServiceList from "../../DB/ServiceData";
import "../../ServiceComponents/ServiceComponentsCSS/ServiceDetails.css";

export default function InnerServiceDetailsPage() {
  const { title } = useParams();
  const [serviceDetails, setServiceDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [selectedService, setSelectedService] = useState(null);

  // function to fetch service details
  const fetchServiceDetails = async (serviceTitle) => {
    const payload = { title: serviceTitle };

    try {
      setLoading(true);
      const res = await getServiceDetails(payload);

      if (res?.data?.status === "success") {
        const apiData = res?.data?.data || [];
        if (apiData.length > 0) {
          setServiceDetails(apiData);
          setMessage("");
        } else {
          setServiceDetails([]);
          setMessage("No data found");
        }
      } else {
        setServiceDetails([]);
        setMessage("Problem with API");
      }
    } catch (err) {
      console.error("Error fetching service data:", err);
      setMessage("Error fetching data");
    } finally {
      setLoading(false);
    }
  };

  // call when "title" changes
  useEffect(() => {
    if (title) {
      fetchServiceDetails(title);
    }
  }, [title]);

  // Helper to trim words
  const getPreviewText = (html, wordLimit = 50) => {
    const text = html.replace(/<[^>]+>/g, ""); // strip HTML tags
    const words = text.split(" ").filter((w) => w.trim() !== "");
    return words.length > wordLimit
      ? words.slice(0, wordLimit).join(" ") + "..."
      : text;
  };

  return (
    <>
      <style>{`
        .test-image {
          margin-top: 80px;
        }
        .test-content {
          align-items: flex-start !important;
        }
        .see-more-btn {
          margin-top: 10px;
          background: #00796b;
          color: white;
          border: none;
          padding: 6px 14px;
          border-radius: 5px;
          cursor: pointer;
          font-size: 13px;
        }
        .see-more-btn:hover {
          background: #004d40;
        }
        .modal-overlay {
          position: fixed;
          top: 0; left: 0; right: 0; bottom: 0;
          background: rgba(0,0,0,0.6);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
        }
        .modal-content {
          background: white;
          padding: 20px;
          border-radius: 10px;
          width: 70%;
          max-height: 80vh;
          overflow-y: auto;
        }
        .close-btn {
          margin-top: 15px;
          background: #e53935;
          color: white;
          border: none;
          padding: 8px 16px;
          border-radius: 5px;
          cursor: pointer;
        }
        .close-btn:hover {
          background: #b71c1c;
        }
      `}</style>

      <ServiceHeader
        childClass="diagnosticServicesBGSection"
        breadcrumb={<>Services <FaGreaterThan size={15} /> {title} </>}
        title={title}
      />

      <div className="serviceBody-wrapper">
        {/* right side (main content) */}
        <div className="right-content">
          {loading ? (
            <p className="text-center">Loading...</p>
          ) : message ? (
            <p className="text-center">{message}</p>
          ) : (
            <>
              <h2 className="section-heading">About {title}</h2>

              {serviceDetails
                .filter((item) => item.Flag === 1)
                .map((service, i) => {
                  const plainText = service.ServiceDesc.replace(/<[^>]+>/g, "");
                  const wordCount = plainText
                    .split(" ")
                    .filter((w) => w.trim() !== "").length;

                  // Preview text only for Sleep Disorders
                  const previewText =
                    title === "Sleep Disorders"
                      ? getPreviewText(service.ServiceDesc, 50)
                      : plainText;

                  return (
                    <section
                      className="test-details-block"
                      key={service.ServiceId}
                    >
                      <div
                        className={`test-content ${
                          i % 2 === 0 ? "normal" : "reverse"
                        }`}
                      >
                        {/* text */}
                        <div className="test-text">
                          <h3 className="test-title rb-headingTag service-headingTag">
                            {service.ServiceName}
                          </h3>

                          <p style={{ fontSize: "14px", color: "#555" }}>
                            {previewText}
                          </p>

                          {/* show See More only for Sleep Disorders + >50 words */}
                          {title === "Sleep Disorders" && wordCount > 50 && (
                            <button
                              className="see-more-btn"
                              onClick={() => {
                                setSelectedService(service);
                                setIsOpen(true);
                              }}
                            >
                              See More
                            </button>
                          )}

                          <div
                            dangerouslySetInnerHTML={{
                              __html: service.ServiceBranch,
                            }}
                            style={{
                              fontSize: "13px",
                              color: "#333",
                              marginTop: "10px",
                              fontWeight: "500",
                            }}
                          />
                        </div>

                        {/* image */}
                        <div className="test-image">
                          <img
                            src={service.ServiceImage}
                            alt={service.ServiceName}
                          />
                        </div>
                      </div>
                    </section>
                  );
                })}
            </>
          )}
        </div>

        {/* left sidebar */}
        <div className="left-sidebar">
          {/* service box  */}
          <div className="services-box">
            <h4>Other</h4>
            <ul>
              {Object.keys(storedServiceList).map((key, index) => (
                <li key={index}>
                  <Link to={`/service/${key.toLowerCase()}`}>
                    {key}{" "}
                    <span className="arrow">
                      <GoArrowRight size={18} />
                    </span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* book consultant */}
          <div className="consult-box">
            <h4>Book a Consultation:</h4>
            <form>
              <input type="text" placeholder="First Name" />
              <input type="text" placeholder="Last Name" />
              <input type="tel" placeholder="Your Phone" />
              <input type="date" />
              <select>
                <option>Select Service</option>
                {Object.keys(storedServiceList).map((key, index) => (
                  <option key={index} value={key.toLowerCase()}>
                    {key}
                  </option>
                ))}
              </select>
              <button type="submit">Book Online</button>
            </form>
          </div>
        </div>
      </div>

      {/* Modal for full content */}
      {isOpen && selectedService && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h2>{selectedService.ServiceName}</h2>
            <div
              dangerouslySetInnerHTML={{ __html: selectedService.ServiceDesc }}
              style={{ fontSize: "14px", color: "#555" }}
            />
            <button className="close-btn" onClick={() => setIsOpen(false)}>
              Close
            </button>
          </div>
        </div>
      )}

      <ServiceSection />
      <ConsultSection />
    </>
  );
}
